<script>
  import { _ } from 'svelte-i18n';

  export let details = '';
  export let cssClass = '';
</script>

<div class="{cssClass}" data-step="2">
  <div class="cmp steps-rating">
    <fieldset>
      <legend class="iscrizioni-header w-100">
        <h3
          class="step-title d-flex flex-column flex-lg-row align-items-lg-center justify-content-between drop-shadow my-3"
        >
          <span class="d-block text-wrap">{$_('step2.question')}</span>
          <span class="step">{$_('common.step2')}</span>
        </h3>
      </legend>
      <div class="cmp-steps-rating__body">
        <div class="form-group">
          <label for="details" style="width: auto;">{$_('step2.detail')}</label>
          <input
            type="text"
            class="form-control"
            id="details"
            aria-describedby="detailsDescription"
            maxlength="200"
            data-element="feedback-input-text"
            bind:value={details}
          />
          <small id="detailsDescription" class="form-text">
            {$_('step2.max200')}
          </small>
        </div>
      </div>
    </fieldset>
  </div>
</div>
